module.exports = __webpack_public_path__ + "img/certificados.8b17f40f.png";